import { printLogs } from "../../helpers";

export function getNextTime(from, to, freq, { ...tLang }) {
    const allTimes = [];
    // let nextTime = from + freq;
    // check if to bigger than from
    // let timezonehour=Math.abs(new Date().getTimezoneOffset()/60)
    // let timeZoneMinutes=Math.abs(new Date().getTimezoneOffset()%60)
    if ((parseInt(freq) !== 0) && (from < to)) {
        for (let i = from; i < to; i += freq) {
            let fromTime = i / 60;
            // let fromTimeOnly = parseInt(fromTime.toString().split(".")[0])+timezonehour; // hours
            let fromTimeOnly = parseInt(fromTime.toString().split(".")[0]); // hours
            let fromMins = "00";
            if (isFloat(fromTime)) {

                let mins = "0." + fromTime.toString().split(".")[1];
                mins = parseFloat(mins);
                mins = Math.round(mins * 60);
                // mins=mins+timeZoneMinutes
                allTimes.push([parseInt(fromTimeOnly) < 10 ? "0" + parseInt(fromTimeOnly) : parseInt(fromTimeOnly), mins < 10 ? "0" + mins : mins]);
            } else {
                allTimes.push([parseInt(fromTimeOnly) < 10 ? "0" + parseInt(fromTimeOnly) : parseInt(fromTimeOnly), "00"]);
            }

        }
        allTimes.forEach((item) => {
            if (item[0] >= 12) {
                item[2] = tLang.pm
            } else {
                item[2] = tLang.am
            }
        })
        return allTimes
    } else {

        if ((to - from) < freq) {

            let fromTime = from / 60;

            let fromTimeOnly = fromTime.toString().split(".")[0];

            let fromMins = "00";
            if (isFloat(fromTime)) {
           
                let mins = "0." + fromTime.toString().split(".")[1];
                mins = parseFloat(mins);
                mins = Math.round(mins * 60);

                allTimes.push([parseInt(fromTimeOnly) < 10 ? "0" + parseInt(fromTimeOnly) : parseInt(fromTimeOnly), mins < 10 ? "0" + mins : mins]);
            } else {
                allTimes.push([parseInt(fromTimeOnly) < 10 ? "0" + parseInt(fromTimeOnly) : parseInt(fromTimeOnly), "00"]);
            }
        }
        allTimes.forEach((item) => {
            if (item[0] >= 12) {
                item[2] = tLang.pm
            } else {
                item[2] = tLang.am
            }
        })
        return allTimes
    }

}

export function getFromToTimes(from, to, { ...tLang }) {
    const allTimes = [];
    let fromTime = from / 60
    let toTime = to / 60

    let fromTimeOnly = fromTime.toString().split(".")[0];
    let toTimeOnly = toTime.toString().split(".")[0];

    if (isFloat(fromTime)) {

        let mins = "0." + fromTime.toString().split(".")[1];
        mins = parseFloat(mins);
        mins = Math.round(mins * 60);

        allTimes.push([parseInt(fromTimeOnly) < 10 ? "0" + parseInt(fromTimeOnly) : parseInt(fromTimeOnly), mins < 10 ? "0" + mins : mins]);
    } else {
        allTimes.push([parseInt(fromTimeOnly) < 10 ? "0" + parseInt(fromTimeOnly) : parseInt(fromTimeOnly), "00"]);
    }

    if (isFloat(toTime)) {

        let mins = "0." + toTime.toString().split(".")[1];
        mins = parseFloat(mins);
        mins = Math.round(mins * 60);

        allTimes.push([parseInt(toTimeOnly) < 10 ? "0" + parseInt(toTimeOnly) : parseInt(toTimeOnly), mins < 10 ? "0" + mins : mins]);
    } else {
        allTimes.push([parseInt(toTimeOnly) < 10 ? "0" + parseInt(toTimeOnly) : parseInt(toTimeOnly), "00"]);
    }
    allTimes.forEach((item) => {
        if (item[0] >= 12) {
            item[2] = tLang.pm
        } else {
            item[2] = tLang.am
        }
    })
    allTimes.forEach((item) => {
        let d = new Date()
        d.setUTCHours((item[2] == tLang.am ? item[0]:item[0] + 12))
        item[0] = d.getHours()
    })
    return allTimes
}

export const isFloat = (n) => {
    return n === +n && n !== (n | 0);
};

export const getTimeIntwelveFormat = (n) => {
    return (n % 12) || 12;
};

export function getWeekDates(startDate, daysToAdd) {
    let aryDates = [];

    for (let i = 0; i <= daysToAdd; i++) {
        let currentDate = new Date();

        currentDate.setDate(startDate.getDate() + i);
        aryDates.push({
            "dayJson": DayAsString(currentDate.getDay()),
            "currentDate": currentDate.getDate(),
            "MonthAsString": MonthAsString(currentDate.getMonth()),
            "year": currentDate.getFullYear(),
            "timestamp": currentDate.getTime()
        });
    }

    return aryDates;
}

export function getNextTimeForZeroFreq(from, to, freq, { ...tLang }) {
    const allTimes = [];
    if (freq == 0) {
        let fromTime = from / 60
        let toTime = to / 60

        let fromTimeOnly = fromTime.toString().split(".")[0];
        let toTimeOnly = toTime.toString().split(".")[0];

        if (isFloat(fromTime)) {

            let mins = "0." + fromTime.toString().split(".")[1];
            mins = parseFloat(mins);
            mins = Math.round(mins * 60);

            allTimes.push([parseInt(fromTimeOnly) < 10 ? "0" + parseInt(fromTimeOnly) : parseInt(fromTimeOnly), mins < 10 ? "0" + mins : mins]);
        } else {
            allTimes.push([parseInt(fromTimeOnly) < 10 ? "0" + parseInt(fromTimeOnly) : parseInt(fromTimeOnly), "00"]);
        }
    
        if (isFloat(toTime)) {

            let mins = "0." + toTime.toString().split(".")[1];
            mins = parseFloat(mins);
            mins = Math.round(mins * 60);

            allTimes.push([parseInt(toTimeOnly) < 10 ? "0" + parseInt(toTimeOnly) : parseInt(toTimeOnly), mins < 10 ? "0" + mins : mins]);
        } else {
            allTimes.push([parseInt(toTimeOnly) < 10 ? "0" + parseInt(toTimeOnly) : parseInt(toTimeOnly), "00"]);
        }
    }
    allTimes.forEach((item) => {
        if (item[0] >= 12) {
            item[2] = tLang.pm
        } else {
            item[2] = tLang.am
        }
    })
    return allTimes
}
export function getNextTimeForZeroFreqForReservation(from, to, freq, { ...tLang }){
    const allTimes = [];
    let Obj={}
    if (freq == 0) {
        let fromTime = from / 60
        let toTime = to / 60

        let fromTimeOnly = fromTime.toString().split(".")[0];
        let toTimeOnly = toTime.toString().split(".")[0];
    
        if (isFloat(fromTime)) {
            let mins = "0." + fromTime.toString().split(".")[1];
            mins = parseFloat(mins);
            mins = Math.round(mins * 60);
            Obj.formTime=parseInt(fromTimeOnly) < 10 ? "0" + parseInt(fromTimeOnly) : parseInt(fromTimeOnly)
            Obj.fromTimeMin=mins < 10 ? "0" + mins : mins
        } else {
            Obj.formTime=parseInt(fromTimeOnly) < 10 ? "0" + parseInt(fromTimeOnly) : parseInt(fromTimeOnly), "00"
            Obj.fromTimeMin="00"
        }
        if (isFloat(toTime)) {

            let mins = "0." + toTime.toString().split(".")[1];
            mins = parseFloat(mins);
            mins = Math.round(mins * 60);
            Obj.toTime=parseInt(toTimeOnly) < 10 ? "0" + parseInt(toTimeOnly) : parseInt(toTimeOnly)
            Obj.toTimeMin=mins < 10 ? "0" + mins : mins
           
        } else {
            Obj.toTime=parseInt(toTimeOnly) < 10 ? "0" + parseInt(toTimeOnly) : parseInt(toTimeOnly)
            Obj.toTimeMin= "00"
            
        }

      
    }
    printLogs("Obj=======>",Obj)
    allTimes.push(Obj)
   
    allTimes.forEach((item) => {
        if (item.formTime>= 12) {
            item.formTimeT = tLang.pm
        } else {
            item.formTimeT = tLang.am
        }
        if (item.toTime>= 12) {
            item.toTimeT = tLang.pm
        } else {
            item.toTimeT = tLang.am
        }
    })
    printLogs("allTimes=====>",allTimes)
    return allTimes
}
export function isOpenOrClose(arr) {
    let temp = false
    let day = getDayName(new Date(), "en-US")
    let start = ((new Date().getUTCHours()) * 60) + (new Date().getUTCMinutes())
    if (arr.length > 0) {
        arr.forEach(workDay => {
            if (workDay.day[0].code.toLowerCase() == day.toLowerCase()) {
                workDay.entityDayWorkTimes.forEach(itm => {
                    if (start >= itm.fromTime && start < itm.toTime) {
                        temp = true
                    } else {
                        temp = false
                    }
                })
            }

        })
    }
    return temp
}
const getDayName = (date, locale) => {
    return date.toLocaleDateString(locale, { weekday: "long" }).toLowerCase()
}
function DayAsString(dayIndex) {
    var weekdays = new Array(7);
    weekdays[0] = { name: "الأحد", code: "sunday" };
    weekdays[1] = { name: "الأثنين", code: "monday" };
    weekdays[2] = { name: "الثلاثاء", code: "tuesday" };
    weekdays[3] = { name: "الاربعاء", code: "wednesday" };
    weekdays[4] = { name: "الخميس", code: "thursday" };
    weekdays[5] = { name: "الجمعة", code: "friday" };
    weekdays[6] = { name: "السبت", code: "saturday" };

    return weekdays[dayIndex];
}

function MonthAsString(monthIndex) {
    var d = new Date();
    var month = new Array();
    month[0] = "1";
    month[1] = "2";
    month[2] = "3";
    month[3] = "4";
    month[4] = "5";
    month[5] = "6";
    month[6] = "7";
    month[7] = "8";
    month[8] = "9";
    month[9] = "10";
    month[10] = "11";
    month[11] = "12";

    return month[monthIndex];
}
export const processWorkingTimeData=(data,days,status)=>{


// console.log("status============>",status)
    if (data) {
      let newDataFromat = []
  
      JSON.parse(JSON.stringify(data)).workTime.map(d=>{
//   console.log("d======>",d)
//   item.entityDayWorkTimes.filter(
//     (i, x) => x === levelTwo[Categories[newVal].code].findIndex(w => w.id === i.id))
      d.entityWorkDays.filter(item => item.dayId !== null&&(status&&status.includes(item.statusId))).forEach(item => {
        let tempWorkTimeLstIds=[]
        let tempResult=[]
        let tempWorkTime=item.entityDayWorkTimes.sort((a, b) => a.fromTime - b.fromTime).filter(ele=>ele.dayId==item.dayId&&(status&&status.includes(ele.statusId)))
        tempWorkTime.map(ele=>{
            let indexOFWorkTime=tempWorkTimeLstIds.indexOf(ele.id)
            if(indexOFWorkTime==-1){
                tempWorkTimeLstIds.push(ele.id)
                 indexOFWorkTime=tempWorkTimeLstIds.indexOf(ele.id)
                tempResult.push(ele)
            }
        })
        newDataFromat.push(
          {
            "entityId":JSON.parse(JSON.stringify(data)).id,
            "dayId": item.dayId,
            "dayName": item.day[0].code,
            "freq": item.frequencyTime,
            "date": getWeekDates(new Date(), 6).find(dayItem => dayItem.dayJson.code.toLowerCase() == item.day[0].code.toLowerCase()).currentDate,
            "oldFormatWorkTimes": tempResult
          }
        )
      })
    })
    // console.log("newDataFromat==>",newDataFromat)
      let newList=[]
      newDataFromat.forEach(item => {
        item.oldFormatWorkTimes.forEach(itm => {
          itm.fromTime += (-1 * (new Date().getTimezoneOffset()))
          itm.toTime += (-1 * (new Date().getTimezoneOffset()))
          if (itm.fromTime == 1440) {
            let tempDay=days.filter(ele=>ele.id==itm.dayId).length>0&&days.filter(ele=>ele.id==itm.dayId)[0].field2
            let parentDay=days.filter(ele=>ele.code==tempDay)
            itm.dayId=parentDay[0].id
            itm.fromTime=0
          }
           else if(itm.fromTime>1440){
            let tempDay=days.filter(ele=>ele.id==itm.dayId)[0].field2
            let parentDay=days.filter(ele=>ele.code==tempDay)
            itm.dayId=parentDay[0].id
            itm.fromTime=itm.fromTime-1440
          }
          if (itm.toTime == 1440) {
            itm.toTime=0
          }
           else if(itm.toTime>1440){
            itm.toTime=itm.toTime-1440
          }
          newList.push(itm)
        })
      })
  
        let tempList=[]
      newDataFromat.forEach(item => {
        if(tempList.indexOf(item.dayId)==-1){
          tempList.push(item.dayId)
        }
      })
      let newList3=[]
     
      newList3=[]
     tempList.forEach(item => {
      
        let tempList2=newList.filter((ele=>ele.dayId==item)).sort((a, b) => a.fromTime - b.fromTime)
       
       if(tempList2.length!=0){
  
    for(let ele=0;ele<tempList2.length;ele++){
     if(ele<tempList2.length-1  ){
     if((tempList2[ele+1].fromTime-tempList2[ele].toTime)==1){
            tempList2[ele].fromTime=tempList2[ele].fromTime
            tempList2[ele].toTime=tempList2[ele+1].toTime
            tempList2.splice(ele+1,1)
            newList3.push(tempList2[ele])
            ele--
          }
          else{ 
            newList3.push(tempList2[ele])
         }
         }
         else if (ele==tempList2.length-1)
         {
          if(!newList3.includes(tempList2[ele]))
           {
               newList3.push(tempList2[ele])
           }
         }
     }
     }
      
     })
  
  
  
  
      let newDataFromat2=[]
      newDataFromat.forEach(item => {
        newList3.map(ele=>{
          if(ele.dayId==item.dayId){
            newDataFromat2.push(item)
          }
        })
        item.newList=newList3.filter(ele=>ele.dayId==item.dayId)
      })
      newDataFromat2.forEach(item => {
        item.newList=newList3.filter(ele=>ele.dayId==item.dayId)
      })
      return newDataFromat2
    }
  
  
  }